import React from "react";
import { Box, Typography } from "@mui/material";
import type { AssistantArtifactPart } from "../../../chat/types";
import { AnimatedCard } from "../../Common/AnimatedCard";
import { ArtifactExportMenu } from "./ArtifactExportMenu";

/** An HTML body is what the server's `render_html` already emits, and the
 *  other renderers take it as their input — so the same four the doc card
 *  offers apply here. */
const EXPORT_FORMATS = [
  { fmt: "html", label: "HTML" },
  { fmt: "pdf", label: "PDF" },
  { fmt: "docx", label: "DOCX" },
] as const;

export function ArtifactHtmlCard({ part }: { part: AssistantArtifactPart }) {
  return (
    <AnimatedCard variant="sm" sx={{ my: 1, p: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        {part.title && (
          <Typography variant="caption" sx={{ flex: 1 }}>
            {part.title}
          </Typography>
        )}
        {part.status === "streaming" && (
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            streaming…
          </Typography>
        )}
        <ArtifactExportMenu
          artifactId={part.artifact_id}
          title={part.title}
          formats={EXPORT_FORMATS}
          // Only a finished artifact has a body the route can render.
          disabled={part.status !== "complete"}
        />
      </Box>
      <iframe
        sandbox="allow-scripts"
        srcDoc={part.text}
        style={{ width: "100%", height: 320, border: 0, background: "white" }}
        title={part.title ?? "html artifact"}
      />
    </AnimatedCard>
  );
}
